<template>
    <h3>{{ element.text }}</h3>
</template>

<script>
    export default {
        name: "TitleElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>